import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var LsErrorExceptionClass;
function LsErrorException() {
  if (LsErrorExceptionClass === VOID) {
    class $ extends IllegalStateException() {
      constructor(error) {
        return new.target.new_com_lightningkite_lightningserver_LsErrorException_4qml0c_k$(error);
      }
      static new_com_lightningkite_lightningserver_LsErrorException_4qml0c_k$(error) {
        var $this = this.new_kotlin_IllegalStateException_w47ei6_k$('' + error.http_1 + ': ' + error.message_1);
        captureStack($this, $this.$throwableCtor_4);
        $this.error_1 = error;
        return $this;
      }
      get_status_jnf6d7_k$() {
        return this.error_1.http_1;
      }
    }
    initMetadataForClass($, 'LsErrorException');
    LsErrorExceptionClass = $;
  }
  return LsErrorExceptionClass;
}
//region block: exports
export {
  LsErrorException as LsErrorException1ikb4g50zc2ko,
};
//endregion

//# sourceMappingURL=LsErrorException.mjs.map
